import {getSelectedKey} from 'src/utils/app-shell';
import type {PreSendCollector} from './index';


export const routePageCollector: PreSendCollector = {
  id: 'route-page',
  when: ({history}) => Boolean(history?.location?.pathname),
  collect: async ({history}) => {
    const {pathname} = history.location;
    const selectedKey = getSelectedKey(
      pathname,
      window.location.href,
      window.location.pathname.startsWith('/trm'),
    );
    //TODO:(diwakersurya) for now don't send anything from url. backend will define the contract for what they need from url.
    return {};
    //return {pathname, selectedKey};
  },
};
